import {
  Box,
  styled,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Divider,
} from '@mui/material';
import { useState } from 'react';
import { AddStock } from './AddStock';
import { ListAssemblyStock } from './ListAssemblyStock';
import { EditStock } from './EditStock';

const actions = ['Liste', 'Ajouter', 'Modifier'] as const;
type Action = (typeof actions)[number];

export const Stock = () => {
  const [selectedAction, setSelectedAction] = useState<Action>('Liste');

  const handleChangeAction = (event: SelectChangeEvent) => {
    setSelectedAction(event.target.value as Action);
  };

  return (
    <Container>
      <Row justifyContent="space-between">
        <Box component="div">
          <Typography variant="h5">Stock</Typography>
        </Box>

        <Row>
          <FormControl sx={{ width: '200px' }}>
            <InputLabel id="stock-type-label">Action</InputLabel>
            <Select
              labelId="stock-type-label"
              id="stock-action-select"
              value={selectedAction}
              label="Action"
              onChange={handleChangeAction}
            >
              {actions.map((action) => (
                <MenuItem key={action} value={action}>
                  {action}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Row>
      </Row>

      <Divider />

      {selectedAction === 'Ajouter' && <AddStock />}
      {selectedAction === 'Liste' && <ListAssemblyStock />}
      {selectedAction === 'Modifier' && <EditStock />}
    </Container>
  );
};

const Container = styled(Box)({
  display: 'flex',
  gap: 16,
  flexDirection: 'column',
  padding: '30px',
});

const Row = styled(Box)({
  display: 'flex',
  gap: 16,
  flexDirection: 'row',
});
